fetch(
  `${process.env.BASE_URL}content/content.json?version=${process.env.PROJECT_VERSION}`
)
  .then(response => response.json())
  .then(content => {
    window["_cmsContent"] = content
    import(/* webpackMode: "eager" */ "@/main")
  })
